import React from 'react';
import { dummyData } from '../dummy';

const colorSenseBar = dummyData.colorSenseBar;
const temperature = colorSenseBar.temperature;
const saturation = colorSenseBar.saturation;
const brightness = colorSenseBar.brightness;
const contrast = colorSenseBar.contrast;
const gradients = [
    { label: '온도감', desc: '주황 - 보라', from: 'from-orange-500', to: 'to-purple-500', value: temperature },
    { label: '채도', desc: '탁한초록 - 쨍한초록', from: 'from-green-300', to: 'to-green-600', value: saturation },
    { label: '명도', desc: '노랑 - 남색', from: 'from-yellow-400', to: 'to-blue-900', value: brightness },
    { label: '탁도', desc: '밝은 아쿠아 - 탁한 보라', from: 'from-cyan-300', to: 'to-purple-800', value: contrast },
];

export const ColorSenseBar = () => {
    return (
        <div className="w-full flex flex-col gap-6 py-5">
            <div className="text-xl font-bold">온도감</div>

            {gradients.map(({ label, desc, from, to, value }) => {
                const clamped = Math.max(0, Math.min(7, value ?? 0));
                const percent = (clamped / 7) * 100;
                return (
                    <div key={label} className="w-full">
                        <div className="w-full flex items-center justify-between mb-2">
                            <div className="text-base font-medium">{label}</div>
                            <div className="text-sm text-black/60">{desc}</div>
                        </div>
                        <div className="relative w-full">
                            <div className={`w-full h-3 rounded-full bg-gradient-to-r ${from} ${to}`} />
                            <div
                                className="pointer-events-none absolute top-1/2 z-10"
                                style={{ left: `${percent}%`, transform: 'translate(-50%, -50%)' }}
                            >
                                <div className="w-[18px] h-[18px] rounded-full bg-white border border-black/10 shadow-sm opacity-50" />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
